import RpcService  from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

import type TenderParticipationRequest from "@/domains/TenderParticipationRequest/TenderParticipationRequest";

class TenderParticipationRequestsDAO {

    /**
     * Получить запросы на участие в тендере.
     * Тендер обязателен — запрос вне тендера не существует.
     */
    static async getList(
      tenderId: number,
      filters?: {
        partnerId?: number | null,
        productId?: number | null,
      }
    ): Promise<RpcResponse> {
        let partner;
        let product;

        if (filters?.partnerId) {
            partner = { id: filters.partnerId };
        }
        else {
            partner = undefined;
        }

        if (filters?.productId) {
            product = { id: filters.productId };
        }
        else {
            product = undefined;
        }

        return await RpcService.makeRequestSilent('tenderParticipationRequests.getList', {
            tender: { id: tenderId },
            partner,
            product,
        });
    }

    /**
     * Отправить запрос на участие в тендере
     */
    static async send(tenderParticipationRequest: TenderParticipationRequest): Promise<RpcResponse> {
        return await RpcService.makeRequestSilent('tenderParticipationRequests.send', {
            tenderParticipationRequest,
        });
    }
}

export default TenderParticipationRequestsDAO;
